/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selectdate1Inputs */

const en_selectdate1 = /** @type {(inputs: Selectdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select date`)
};

const de_selectdate1 = /** @type {(inputs: Selectdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum auswählen`)
};

/**
* | output |
* | --- |
* | "Select date" |
*
* @param {Selectdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const selectdate1 = /** @type {((inputs?: Selectdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selectdate1(inputs)
	return de_selectdate1(inputs)
});
export { selectdate1 as "selectDate" }